import { Tabs } from 'antd';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Customer from './Customer';
import { GetSPCustomer, GetSPOrderDetail, GetSPSampleDetail } from '../../../../API/GetData';
import SampleDetail from './SampleDetail';
import OrderDetail from '../../Order/OrdersDetail/OrderDetail';
import { decrypt } from '../../../../Utils/CryptoHelper';

const SamplesDetail = () => {
  const params = useParams();
  const { accountid, code } = params;

  const DecAccountId = decrypt(decodeURIComponent(accountid));
  const DecCode = decrypt(decodeURIComponent(code));

  const [dataSource, setDataSource] = useState([]);
  const [dataOrder, setDataOrder] = useState(null);
  const [dataCustomer, setDataCustomer] = useState(null);

  // Detail Sample
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await GetSPSampleDetail(DecAccountId, DecCode);
        setDataSource(res);
      } catch (error) {
        console.log(error);
      }
    };


    if (DecAccountId && DecCode) {
      fetchData();
    }
  }, [DecAccountId, DecCode]);

  // Detail Order
  useEffect(() => {
    const fetchDataOrder = async () => {
      try {

        const orderCode = dataSource && dataSource.OrderCode ? dataSource.OrderCode : '';

        if (orderCode) {
          const response = await GetSPOrderDetail(DecAccountId, orderCode);
          setDataOrder(response);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchDataOrder();
  }, [DecAccountId, dataSource]);

  // DETAIL CUSTOMER
  useEffect(() => {
    const fetchDataCustomer = async () => {
      try {
        const response = await GetSPCustomer(dataOrder?.Order?.CustomerId);
        setDataCustomer(response);
      } catch (error) {
        console.log(error);
      }
    }
    if (dataOrder && dataOrder?.Order?.CustomerId) {
      fetchDataCustomer();
    }
  }, [DecAccountId, dataOrder]);


  const items = [
    {
      key: '1',
      label: 'Sample',
      children: <SampleDetail dataSource={dataSource} />,
    },
    {
      key: '2',
      label: 'Order',
      children: <OrderDetail dataSource={dataOrder} />,
    },
    {
      key: '3',
      label: 'Customer',
      children: <Customer dataSource={dataCustomer} />,
    },
  ];

  return (
    <div className="bg-white p-4 rounded-md">
      <div className="flex flex-col mb-2">
        <p className="text-xl font-medium">DETAIL SAMPLE</p>
        <p className="text-lg font-medium text-second">{dataSource.RFNumber}</p>
      </div>
      <Tabs defaultActiveKey="1" items={items} />
    </div>
  )
}

export default SamplesDetail